module.exports = __webpack_public_path__ + "img/HZ-A0152.18c39a80.jpg";